export default {
    UPDATE_USER(state, payload) {
        // Update state
        state.user = payload.detail.name
        state.token = payload.access_token

        // Store localstorage
        localStorage.setItem('token', payload.access_token)
        localStorage.setItem('userid', payload.detail.id)
        localStorage.setItem('name', payload.detail.name)
        localStorage.setItem('email', payload.detail.email)
        localStorage.setItem('role', payload.detail.role)
        localStorage.setItem('photo_profile', payload.detail.photo_profile)
    },
    LOGOUT_USER(state) {
        state.user = null
        state.token = null
        localStorage.removeItem('token')
        localStorage.removeItem('userid')
        localStorage.removeItem('name')
        localStorage.removeItem('email')
        localStorage.removeItem('role')
        localStorage.removeItem('photo_profile')
    }
}